import { o as e, c, a as o } from "./core.0767a1be.js";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "none",
  viewBox: "0 0 20 20"
}, l = /* @__PURE__ */ o("circle", {
  cx: "10",
  cy: "10",
  r: "10",
  fill: "#000",
  "fill-opacity": ".1"
}, null, -1), n = [
  l
];
function s(r, a) {
  return e(), c("svg", t, n);
}
const d = { render: s };
export {
  d as default,
  s as render
};
//# sourceMappingURL=non-selected-cycle.80181d02.js.map
